import { type RecordId } from 'javascripts/shared-types';
import ItemFilter from './ItemFilter';

class RecordFilter extends ItemFilter<RecordId> {
  matches(record: any) {
    return super.matches(record) || this.itemIsSelected(record?.id);
  }
}

export default RecordFilter;
